<template>
    <v-list class="d-block d-md-none" dense>
        <v-list-item
            :to="{name: 'tech'}"
            :class="isCurrentTab('tech') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-tune-vertical</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Compétences</v-list-item-content>
        </v-list-item>

        <v-list-item
            :to="{name: 'xp'}"
            :class="isCurrentTab('xp') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-briefcase-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Expériences</v-list-item-content>
        </v-list-item>

        <v-list-item
            :to="{name: 'hobbies'}"
            :class="isCurrentTab('hobbies') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-tennis</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Hobbies</v-list-item-content>
        </v-list-item>

        <div class="contact d-flex align-center mt-12">
            <v-list-item href="mailto:" ref="mailto" @click="mailto" target="_blank" dense>
                <v-list-item-icon>
                    <v-icon>mdi-at</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item href="https://www.linkedin.com/in/david-ronsain-33416076/" target="_blank" dense>
                <v-list-item-icon>
                    <v-icon>mdi-linkedin</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item class="justify-center" href="tel:" target="_blank" ref="tel" @click="tel">
                <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
            </v-list-item>
        </div>
    </v-list>
</template>

<script>
export default {
    name: 'mobileMenu'
}
</script>

<style scoped lang="scss">
@import '../../assets/css/variables.scss';

.v-list {
    background-color: $c-red !important;
    color: $c-white !important;

    .v-list-item {
        text-align: center !important;
        color: $c-white !important;
        font-weight: 600;

        .v-list-item__icon:first-child {
            margin-right: 12px !important;
        }

        &--active:before, &--active:hover:before, &--active:focus:before, &--highlighted:before {
            opacity: 0 !important;
        }

        &.selected {
            border-left: 4px white solid !important;
        }
    }

    .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: $c-white !important;

        .v-icon {
            color: $c-white !important;
        }
    }

    .contact > a {
        max-width: max-content !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/mobileMenu.vue